<script>import { getComponent } from "./resolvers";
export let component = void 0;
export let components = void 0;
</script>

{#if components && components.length}
	{#each components as component, i (component?.id || i)}
		{#if component}
			<svelte:component this={getComponent(component.name)} {...component.props} />
		{/if}
	{/each}
{/if}

{#if component}
	<svelte:component this={getComponent(component.name)} {...component.props} />
{/if}
